import React from "react";

const Policy = ({ policyName }) => {
  return (
    <div className="policy-container">
      <h2 className="policy-title1">개인 정보 수집 및 이용</h2>

      <h2 className="policy-title">■ 개인정보처리방침</h2>
      <br />
      <p className="policy-text">개인정보 수집주체: {policyName}</p>
      <p className="policy-text">개인정보 수집항목: 이름, 연락처, 상담내용</p>
      <p className="policy-text">
        개인정보 수집 및 이용목적: {policyName}에서 예약 상담 활용(전화,문자)
      </p>
      <p className="policy-text">
        개인정보 보유 및 이용기간: 수집일로부터 5년(고객 등의 철회시 지체없이
        파기)
      </p>
      <br />
      <br />
      <h2 className="policy-title">■ 개인정보 취급 위탁</h2>
      <br />
      <p className="policy-text">개인정보 취급위탁을 받는 자 : {policyName}</p>
      <p className="policy-text">
        개인정보 취급위탁을 하는 업무의 내용: 홈페이지 운영 및 관리, 이벤트 등
        광고성 정보 전달, 고객정보 저장 및 서버관리
      </p>
      <p className="policy-text">
        *상기 동의를 거부할 관리가 있으며, 수집 및 이용에 동의하지 않을 경우
        {policyName}의 예약 상담 및 우대혜택이 불가능합니다.
      </p>
      <style jsx>{`
        .policy-container {
          max-width: 600px;
          margin: 0 auto;
          padding: 20px;
          border-radius: 8px;
        }
        .policy-title1 {
          text-align: center;
          font-size: 2rem;
          margin-bottom: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #e2e2e2;
        }
        .policy-title {
          font-size: 1.5rem;
          margin-bottom: 10px;
          color: #333;
        }

        .policy-text {
          line-height: 1.6;
          margin-bottom: 10px;
          color: #555;
        }

        @media (max-width: 768px) {
          .policy-container {
            padding: 15px;
          }

          .policy-title {
            font-size: 1.3rem;
          }

          .policy-text {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Policy;
